/* eslint-disable class-methods-use-this */
// SHOP-9362 [FrontEnd] - Интеграция кода партнера  ADV.CAKE
class AdvCakeEvents {
  setEventForProduct({ product, basketData }) {
    // @ts-ignore
    const advCake = window?.advcake_data || [];

    const currentProduct = {
      id: product.productId,
      name: product.productName,
      price: product.price.value,
    };

    const currentCategory = {
      id: product.impression.category,
      name: product.impression.mainCollectionName,
    };

    const basketProducts = basketData.map((item) => ({
      id: item.id,
      name: item.productName,
      price: item.price,
      quantity: item.quantity,
      categoryId: item.categoryId,
      categoryName: item.categoryName,
    }));

    advCake.push({
      pageType: 2,
      user: {
        // emil в виде хеша или уникальный идентификатор, если не передается, данное поле можно оставить пустым
        email: '',
      },
      currentCategory,
      currentProduct,
      basketProducts,
    });
  }

  setEventForCatalog({ category, productList, basketData }) {
    // @ts-ignore
    const advCake = window?.advcake_data || [];

    const basketProducts = basketData.map((item) => ({
      id: item.id,
      name: item.productName,
      price: item.price,
      quantity: item.quantity,
      categoryId: item.categoryId,
      categoryName: item.categoryName,
    }));

    const currentCategory = {
      id: category.id,
      name: category.name,
    };

    const products = productList.map((item) => ({
      id: item.id,
      name: item.title,
      price: item.price.value,
    }));

    advCake.push({
      pageType: 3,
      user: {
        // emil в виде хеша или уникальный идентификатор, если не передается, данное поле можно оставить пустым
        email: '',
      },
      currentCategory,
      products,
      basketProducts,
    });
  }
}

export const advCakeEvents = new AdvCakeEvents();
